import { Controller } from "@hotwired/stimulus"

// Выпадающее меню в шапке. Поддерживает hover (через CSS) и клик/тач (через классы).
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.onDocClick = this.handleDocClick.bind(this)
    this.onKey = this.handleKey.bind(this)
    document.addEventListener("click", this.onDocClick)
    document.addEventListener("keydown", this.onKey)
  }

  disconnect() {
    document.removeEventListener("click", this.onDocClick)
    document.removeEventListener("keydown", this.onKey)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    const isOpen = this.element.classList.toggle("open")
    const toggle = this.element.querySelector(".nav-dropdown-toggle")
    toggle?.setAttribute("aria-expanded", isOpen ? "true" : "false")
  }

  close() {
    this.element.classList.remove("open")
    const toggle = this.element.querySelector(".nav-dropdown-toggle")
    toggle?.setAttribute("aria-expanded", "false")
  }

  handleDocClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  handleKey(event) {
    if (event.key === "Escape") this.close()
  }
}
